// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__yqQJ8","btnRed":"styles_btnRed__2Gh5e","title":"styles_title__w_4S8"};